import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import initialState from './cbpCaseManagerInitialState';
import axios from 'axios';
import {
  _setCaseManager,
  _setReferralType,
  _setStartDate,
  _setEndDate,
  //_setCbpCmID,
} from './cbpCaseManagerActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getCbpCaseManagerForm = createAsyncThunk(
  'stop/getCbpCaseManagerForm',
  async (params) => {
    const { cbpCaseManagerUrl, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(cbpCaseManagerUrl, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

export const cbpCaseManagerSlice = createSlice({
  name: 'cbpCaseManager',
  initialState,
  reducers: {
    setCaseManager: _setCaseManager,
    setReferralType: _setReferralType,
    setStartDate: _setStartDate,
    setEndDate: _setEndDate,
    //setCbpCmID: _setCbpCmID,
    newCaseManager: (state, action) => action.payload,
  },
  extraReducers: {
    [getCbpCaseManagerForm.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  setCaseManager,
  setReferralType,
  setStartDate,
  setEndDate,
  newCaseManager,
  //setCbpCmID,
} = cbpCaseManagerSlice.actions;

export default cbpCaseManagerSlice.reducer;
